<template>
    <div class="collection-background" :style="propertyStyle">
        <transition tag="div">
        <div class="collection-sheet" v-if="displayFlag">
            <div class="collection_area">
                <div v-for="(nowItem,index) in displayListSlice" class="cell cell-contents" :key="index" :ref="'item'+index" @click="fireEvent(index)" ontouchstart="">
                    <div class="image-box">
                        <img :src="thumbnailUrl(itemSource[nowItem].dir)" height="100%" :alt="itemSource[nowItem].info.title">
<!--                        <div class="image-box-button">-->
<!--                            <button style="width: 60%; height: 24px;" @click.stop="fireEvent(props.index)">読む</button>-->
<!--                        </div>-->
                    </div>
                    <div class="description">
                        <div class="author">{{itemSource[nowItem].info.author}}</div>
                        <div class="title">{{itemSource[nowItem].info.title}}</div>
                    </div>
                    <div></div>
                    <div class="affiliate-box">
                        <div :style="{display: 'inline-block', margin: '0 4px', color: itemSource[nowItem].info.affiliates['Amazon'] ? '#444444' : '#CCCCCC',}">
                            <svg :width="afiIconSize+'px'" :height="afiIconSize+'px'" viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <title>Afi_Amazon</title>
                                <g id="Afi_Amazon" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                    <g id="Group">
                                        <rect id="Rectangle" stroke="currentColor" fill="#FFFFFF" x="0.5" y="0.5" width="39" height="39"></rect>
                                        <path d="M16.99375,33.91875 C18.45625,33.91875 19.88125,33.65625 21.26875,33.13125 C22.46875,32.68125 23.65625,31.9875 24.83125,31.05 C24.89375,31.3375 24.975,31.66875 25.075,32.04375 C25.175,32.41875 25.2875,32.8 25.4125,33.1875 L25.4125,33.1875 L32.18125,33.1875 C31.93125,32.3625 31.73125,31.578125 31.58125,30.834375 C31.43125,30.090625 31.34375,29.3875 31.31875,28.725 C31.29375,28.1125 31.275,27.515625 31.2625,26.934375 C31.25,26.353125 31.24375,25.78125 31.24375,25.21875 L31.24375,25.21875 L31.24375,15.0375 C31.24375,13.7375 31.13125,12.6 30.90625,11.625 C30.68125,10.65 30.35625,9.8625 29.93125,9.2625 C29.63125,8.85 29.1375,8.428125 28.45,7.996875 C27.7625,7.565625 26.95,7.16875 26.0125,6.80625 C25.225,6.51875 24.35625,6.29375 23.40625,6.13125 C22.45625,5.96875 21.4625,5.8875 20.425,5.8875 C18.2625,5.8875 16.35625,6.20625 14.70625,6.84375 C13.69375,7.24375 12.821875,7.6875 12.090625,8.175 C11.359375,8.6625 10.775,9.16875 10.3375,9.69375 C9.2,11.09375 8.63125,12.325 8.63125,13.3875 L8.63125,13.3875 L8.63125,13.9125 L15.625,13.9125 L15.625,13.35 C15.625,12.1625 15.9875,11.2875 16.7125,10.725 C17.6875,9.95 18.86875,9.5625 20.25625,9.5625 C21.40625,9.5625 22.50625,9.88125 23.55625,10.51875 C24.28125,10.95625 24.64375,12.025 24.64375,13.725 L24.64375,13.725 L24.64375,16.66875 L23.2,16.95 C20.575,17.475 18.29375,18.04375 16.35625,18.65625 C14.41875,19.26875 12.94375,19.9 11.93125,20.55 C10.70625,21.35 9.790625,22.24375 9.184375,23.23125 C8.578125,24.21875 8.275,25.325 8.275,26.55 C8.275,28.6625 9.15,30.46875 10.9,31.96875 C12.425,33.26875 14.45625,33.91875 16.99375,33.91875 Z M18.4375,30.2625 C17.925,30.2625 17.471875,30.16875 17.078125,29.98125 C16.684375,29.79375 16.35,29.5375 16.075,29.2125 C15.8,28.8875 15.59375,28.50625 15.45625,28.06875 C15.31875,27.63125 15.25,27.15625 15.25,26.64375 C15.25,25.18125 15.71875,24.08125 16.65625,23.34375 C16.96875,23.10625 17.384375,22.859375 17.903125,22.603125 C18.421875,22.346875 19.028125,22.090625 19.721875,21.834375 C20.415625,21.578125 21.178125,21.321875 22.009375,21.065625 C22.840625,20.809375 23.71875,20.5625 24.64375,20.325 L24.64375,20.325 L24.64375,22.3875 C24.64375,24.075 24.3625,25.425 23.8,26.4375 C23.0375,27.8 22.25,28.725 21.4375,29.2125 C20.85,29.5625 20.3125,29.825 19.825,30 C19.3375,30.175 18.875,30.2625 18.4375,30.2625 Z" id="a" fill="currentColor" fill-rule="nonzero"></path>
                                    </g>
                                </g>
                            </svg>
                        </div>
                        <div :style="{display: 'inline-block', margin: '0 4px', color: itemSource[nowItem].info.affiliates['Kindle'] ? '#444444' : '#CCCCCC',}">
                            <svg :width="afiIconSize+'px'" :height="afiIconSize+'px'" viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <title>Afi_Kindle</title>
                                <g id="Afi_Kindle" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                    <g id="Group">
                                        <rect id="Rectangle" stroke="currentColor" fill="#FFFFFF" x="0.5" y="0.5" width="39" height="39"></rect>
                                        <path d="M16.125,23.578125 L25.8125,35 L30.375,35 L20.5625,23.3125 L30.015625,13.1875 L25.8125,13.1875 L16.125,23.578125 Z M16.125,23.578125 L16.125,3.46875 L12.34375,3.46875 L12.34375,35 L16.125,35 L16.125,23.578125 Z" id="k" fill="currentColor" fill-rule="nonzero"></path>
                                    </g>
                                </g>
                            </svg>
                        </div>
                        <div :style="{display: 'inline-block', margin: '0 4px', color: itemSource[nowItem].info.affiliates['Rakuten'] ? '#444444' : '#CCCCCC',}">
                            <svg :width="afiIconSize+'px'" :height="afiIconSize+'px'" viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <title>Afi_Rakuten</title>
                                <g id="Afi_Rakuten" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                    <g id="Group">
                                        <rect id="Rectangle" stroke="currentColor" fill="#FFFFFF" x="0.5" y="0.5" width="39" height="39"></rect>
                                        <path d="M15.8,34 L15.8,22.5771144 L17.6,22.5771144 L24.4,34 L31,34 L22.8,22.0199005 C27.3333333,20.9054726 29.6,18.305141 29.6,14.2189055 C29.6,11.5257048 28.5333333,9.43615257 26.4,7.95024876 C24.5333333,6.65008292 21.5333333,6 17.4,6 L17.4,6 L10,6 L10,34 L15.8,34 Z M17.3243243,19 L16,19 L16,10 L17.7027027,10 C21.2342342,10 23,11.4328358 23,14.2985075 C23,17.4328358 21.1081081,19 17.3243243,19 L17.3243243,19 Z" id="R" fill="currentColor" fill-rule="nonzero"></path>
                                    </g>
                                </g>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </transition>
        <div class="paging-indexes">
            <div v-if="resultPageLinks" class="paging-index-box" style="width: 80%;">
                <div>
                    <span v-for="(value,index) in resultPageLinks" :key="index" @click="pageSwitch(value)" :style="{fontWeight: ((value - 1) === nowPage ? '900' : null),color: (value - 1) !== nowPage ? '#3e85d2' : null, marginLeft : '1em'}">
                        {{value === 0 ? '...' : value}}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  let debugOut = false
  import {mapState} from 'vuex'
  export default {
    name: "WorklistCollection",
    components: {
    },
    data() {
      return {
        cellWidth: 200,
        cellHeight: 200,
        cellMargin: 16,
        imageSize: 160,
        activeCaption:-1,
        nowPage:0,

        displayFlag:true,

        afiIconSize: 16,
      }
    },
    props: {
      itemIndexes:Array,
      itemSource:Array,
      transitionUpdate: {
        type: Number,
        default: 0,
      },
      docWidth:Number,
    },
    watch: {
      transitionUpdate(nValue,oValue) {
        this.doTransition()
      },
    },
    created() {
      debugOut = this.$root.$options.debugOut
    },
    mounted() {
    },
    computed: {
      itemCountOfPage() {
        return 20
      },
      numberOfColumn() {
        return Math.floor(this.docWidth / (this.cellWidth + this.cellMargin * 2))
      },
      numberOfPages() {
        if (this.itemIndexes == null) { return 0 }
        let count = this.itemIndexes.length
        if (count === 0) { return 0 }
        return Math.ceil(count / (this.itemCountOfPage))
      },
      displayListSlice() {
        if (this.numberOfPages === 0) { return  null }
        let count = this.itemIndexes.length
        if (this.nowPage > this.numberOfPages) { this.nowPage = this.numberOfPages }
        let start =  this.itemCountOfPage * this.nowPage
        let end = start + this.itemCountOfPage
        if (end > count) { end = count }
        return this.itemIndexes.slice(start,end)
      },
      resultPageLinks() {
        if (!this.itemIndexes || this.itemIndexes.length === 0) return null
        if (this.numberOfPages <= 10) {
          let list = [...Array(this.numberOfPages + 1).keys()]
          list.shift()
          return list
        }

        const clmn = 6
        let start = this.nowPage - (clmn - 1)
        if (start < 2) start = 2
        let end = start + (clmn - 1)
        if (end > this.numberOfPages - 1) {
          end = this.numberOfPages - 1
          start = end - (clmn - 1)
          if (start < 2) start = 2
        } else {
          if (end === this.nowPage) {
            end = this.nowPage + 3
            if (end > this.numberOfPages - 1) end = this.numberOfPages - 1
            start = end - (clmn - 1)
            if (start < 2) start = 2
          }
        }
        if(debugOut) {console.log(`${start}〜${end}`)}
        let list = [1]
        if (start !== 2) list.push(0)
        list = list.concat([...Array(end - start + 1).keys()].map(value => value + start))
        if (end !== this.numberOfPages - 1) list.push(0)
        list.push(this.numberOfPages)

        return list
      },
      papiDir() {
        return this.$root.$options.commandPath
      },
      propertyStyle() {
        return {
          '--cell-height'       : this.cellHeight+'px',
          '--cell-width'        : this.cellWidth+'px',
          '--cell-margin'       : this.cellMargin+'px',
          '--cell-unit'         : (this.cellWidth + (this.cellMargin * 2))+'px',
          '--cell-area-width'   : ((this.cellWidth + (this.cellMargin * 2)) * this.numberOfColumn)+'px',
          '--image-size'        : this.imageSize+'px',
          '--title-size'        : '1.1em',
          '--author-size'       : '0.9em',
          '--doc-width'         : this.docWidth+'px',
          '--affi-height'       : (this.afiIconSize + 4)+'px',
      }
      },
      ...mapState([
        // 'documentAreaWidth',
        // 'documentAreaHeight',
      ]),
    },
    methods: {
      pageSwitch(i) {
        if (this.nowPage === (i - 1)) return
        if (debugOut) {console.log(`page switch to ${i}`)}
        if ((i < 1) || (i > this.numberOfPages)) return
        this.nowPage = i - 1
        this.doTransition()
      },
      onScroll(e) {
        if (debugOut) { console.log(e) }
      },
      thumbnailUrl(t) {
        return `${this.$root.$options.sharePath}/${t}/thumbnail.jpg`
      },
      fireEvent(i) {
        if (debugOut) {console.log(`click cell index ${i} -> ${this.displayListSlice[i]}`)}
        this.$emit("popCandidate",this.displayListSlice[i])
      },
      doTransition() {
        this.displayFlag = false
        this.$nextTick(() => {
          setTimeout(() => {
            this.displayFlag = true
          },100)
        })
      },

    },
  }
</script>

<style scoped >

    .cell-contents {
        --padding-ib:   4px;
    }
    .image-box {
        display: block;
        position: relative;
        /*width: calc(var(--image-size) + 8px);*/
        /*height: var(--image-size);*/
        /*padding: var(--top-padding-ib) 4px var(--bottom-padding-ib) 4px;*/
        width: calc(100% - calc(var(--padding-ib) * 2));
        height: calc(100% - calc(var(--padding-ib) * 2));
        padding: var(--padding-ib);
        margin: 0 auto;
     }
    .image-box img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        pointer-events: none;
    }
    .description {
        position: absolute;
        font-size: 0.8rem;
        font-weight: bold;
        text-align: center;
        text-shadow:1px 1px 0 #FFF, -1px -1px 0 #FFF,
        -1px 1px 0 #FFF, 1px -1px 0 #FFF,
        0px 1px 0 #FFF,  0-1px 0 #FFF,
        -1px 0 0 #FFF, 1px 0 0 #FFF;
        word-break: keep-all;
        bottom: var(--affi-height);
        left: 5%;
        width: 90%;
        height: 4rem;
    }
    .description .author {
        font-size: 0.9rem;
        font-weight: normal;
    }
    .description .title {

    }

    .affiliate-box {
        display: inline-block;
        position: absolute;
        width: 90%;
        margin: 0 auto 0 0;
        padding-top: 2px;
        height: var(--affi-height);
        text-align: right;
        bottom: 0;
    }

    .collection-background {
        display: block;
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 5;
        /*background-color: rgba(0, 0, 0, 0.2);*/
        user-select: none;
    }
    .collection-sheet {
        --top-padding-cs: 10%;
        display: flex;
        justify-content: center;
        position: relative;
        width: var(--cell-area-width);
        height: calc(100% - var(--top-padding-cs));
        margin: 0 auto;
        top: var(--top-padding-cs);
        overflow: scroll;
    }
    .collection_area {
        display: flex;
        flex-flow: wrap;
        position: absolute;
        border: none;
        vertical-align: top;
        overflow-y: auto;
        right: 0;
        top: 0;
        /*max-width: 100%;*/
        /*width: calc(var(--cell-unit) * mod(100%, var(--cell-unit)));*/
        width: 100%;
        height: calc(100% - 1.5em);
        padding: 0;
        text-align: left;
        flex-shrink: 0;
    }
    .cell {
        display: block;
        position: relative;
        flex-shrink: 0;
        width: var(--cell-width);
        height: var(--cell-height);
        margin: var(--cell-margin);
        background-color: #ffffffA0;
        border-radius: 8px;
        box-shadow: #00000033 2px 2px 4px;
        overflow: hidden;
    }
    .cell:hover {
        left: -2px;
        top: -2px;
        /*width: calc(var(--cell-width) + 8px);*/
        /*height: calc(var(--cell-height) + 8px);*/
        box-shadow: #00000033 5px 5px 8px;
    }
    .cell::before {
        position: absolute;
        top: 0;
        left: -75%;
        z-index: 2;
        display: block;
        content: '';
        width: 50%;
        height: 100%;
        background: -webkit-linear-gradient(left, rgba(255,255,255,0) 0%, rgba(255,255,255,.3) 100%);
        background: linear-gradient(to right, rgba(255,255,255,0) 0%, rgba(255,255,255,.3) 100%);
        -webkit-transform: skewX(-25deg);
        transform: skewX(-25deg);
    }
    .cell:hover::before {
        -webkit-animation: shine .75s;
        animation: shine .75s;
    }
    @-webkit-keyframes shine {
        100% {
            left: 125%;
        }
    }
    @keyframes shine {
        100% {
            left: 125%;
        }
    }

    .v-enter-active, .v-leave-active {
        /*will-change: opacity;*/
        transition: opacity 300ms cubic-bezier(.3,1,.5,1) 0ms;
    }
    .v-enter, .v-leave-to {
        opacity: 0
    }

    .list-transition-enter-active {
        opacity: 0;
        transform: translateX(50px);
        transition-property: transform, opacity;
        transition-duration: 0.6s;
        transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);
        transition-delay: 0s;
    }
    .list-transition-enter-to {
        opacity: 1;
        transform: translateX(0);
    }
    .list-transition-leave-active {
        opacity: 1;
        transform: translateX(0);
        transition-property       : transform, opacity;
        transition-duration       : 0.6s;
        transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);
        transition-delay          : 0s;
    }
    .list-transition-leave-to {
        opacity: 0;
        transform: translateX(50px);
    }
    .list-transition-move {
        transition-property       : transform;
        transition-duration       : 0.6s;
        transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);
        transition-delay          : 0s;
    }


    .paging-indexes {
        display: inline-block;
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
    }

    .paging-index-box {
        display: flex;
        flex-flow: column;
        text-align: center;
        margin: 0 auto;
    }
</style>